import formatUser from './utils/formatUser'
import axios from 'axios'

export default {
  install: (Vue, {auth}) => {
    Vue.prototype.$auth = new Vue({
      data () {
        return {
          user: null,
          token: null,
          depotVente: null
        }
      },

      methods: {
        setUser (user) {
          if (user) {
            this.user = formatUser(user)
          }
        },

        setUserToken (token) {
          if (token) {
            this.user.token = token
          }
        },

        setToken (token) {
          if (token) {
            this.token = token
          }
        },

        isConnected () {
          return new Promise((resolve) => {
            auth.getConnectedUser()
              .then(user => {
                this.setUser(user);
                axios.defaults.headers = {
                  'Authorization': 'Bearer ' + this.token
                };
                resolve(true);
              })
          })

        },

        init () {
          return new Promise((resolve) => {
            let data = ''
            auth.verifUrl(window.location.host)
              .then(response => {
                if (response.marque === true) {
                  this.setToken(response.token)
                }
                data = response
                resolve(data)
              })
          })

        },

        login (email, idSoft, depotVente, marque) {
          return new Promise((resolve) => {
            auth.login(email, idSoft, depotVente, marque)
              .then(response => {
                this.setUser(response.user)
                if (marque === false) {
                  this.setToken(response.token)
                  this.setUserToken(this.token)
                } else {
                  this.setUserToken(this.token)
                }
                localStorage.setItem('user', JSON.stringify(this.user))
                axios.defaults.headers = {
                  'Authorization': 'Bearer ' + this.token
                }
                resolve(true)
              })
              .catch(console.error)
          })
        },

        logout () {
          auth.logout()
            .then(() => {
              this.user = null
            })
            .catch(console.error)
        }
      }
    })
  }
}
